import React, { useEffect, useState } from 'react'
import { Box, Table, Button } from '@mui/material'
import { ApiGetReportlist } from '../../apiService/Core/Apicall'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import storage from '../../utils/storage'

function CheckScoreCard() {
    const [reportList, setreportlist] = useState<any>([])
    const navigate = useNavigate()

    const getreportlist = async () => {
        try {
            const data = `?offset=0&limit=100&reportMonth=5&reportYear=2025&reportStatusId=1&projectGroupName=${storage.getItem('ClientGroupName')}&clientEntityId=${storage.getItem('clientEntityId')}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
            const res = await ApiGetReportlist(data)
            setreportlist(res.data)


        } catch (error: any) {
            toast.error(error.message)
        }

    }
    console.log('Set Report List', reportList)
    useEffect(() => {
        getreportlist()
    }, [])

    const handleEditScoreCard = (allocationId: any) => {
        // const url = `createOrEditScoreCard/703?clientGroup=${storage.getItem('ClientGroupName')}`
        // window.open(url, '_blank')
        navigate(`/createOrEditScoreCard/703`, {
          state: { clientGroup: storage.getItem('ClientGroupName')},
        });
        //window.open(`/createOrEditScoreCard/${allocationId}`, "_blank");
    };
    return (
        <Box>
            {
                reportList.length > 0 && reportList?.map((item:any,index:any)=>(

                    <Button className='button-primary' onClick={() => {handleEditScoreCard(item.allocationId)}}>{item.allocationId} View Report</Button>
                ))
            }
        </Box>
    )
}

export default CheckScoreCard
